// src/services/customerApi.js
// Centralized API calls for managing customers

import axiosInstance from "./axiosInstance"; // pre-configured axios instance

export const downloadCustomerImages = (customerId) =>
    axiosInstance.get(`/superadmin/customers/${customerId}/images-backup`, { responseType: "blob" });

export const fetchCustomerImageBackupStatus = (customerIds) =>
    axiosInstance.get('/superadmin/customers/images-backup-status', { params: { customer_ids: customerIds.join(',') } });

// Get all customers (supports pagination + search)
export const fetchCustomers = (page = 1, search = "") =>
    axiosInstance.get(`/superadmin/customers`, {
        params: { page, search },
    });

// Update status (ACTIVE / INACTIVE / DELETED)
export const updateCustomerStatus = (id, status) =>
    axiosInstance.put(`/superadmin/customers/${id}/status`, { status });

// Create customer
export const createCustomer = (data) =>
    axiosInstance.post(`/superadmin/customers`, data);

// Edit customer
export const editCustomer = (id, data) =>
    axiosInstance.put(`/superadmin/customers/${id}`, data);

// Reset linked admin password and email the temporary password
export const resetCustomerAdminPassword = (customerId, userId) =>
    axiosInstance.post(`/superadmin/customers/${customerId}/admin-password-reset`, {
        user_id: userId,
    });

// Soft-delete customer (sets status = DELETED)
export const deleteCustomer = (id) =>
    axiosInstance.put(`/superadmin/customers/${id}/status`, { status: "DELETED" });
